import * as Highcharts from 'highcharts'

const fontFamily =
  // eslint-disable-next-line max-len
  ' "メイリオ", Meiryo, "游ゴシック", "Yu Gothic", YuGothic, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif '

let chart = null

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
})

const breakPoint = (isResponsive) => window.innerWidth > 640 || !isResponsive

export function makeChart(id, series, startAge, interest, isResponsive, onHover) {
  const safeOnHover =
    onHover && typeof onHover === 'object' && !Array.isArray(onHover) ? onHover : {}

  chart = null
  // TODO デザイン (margin)
  const _marginTop = 50
  const _marginLeft = 80
  const _marginRight = 60
  const _marginBottom = 100
  const _highlightAge = 100
  const _endAge = 120
  const _dataLength = _endAge - startAge
  const _tickTotal = 12
  const _tickUnit = calcTickUnit(_dataLength, _tickTotal, isResponsive)

  // y軸ラベルの最大値で丸める単位を決定
  const allValues = series.flatMap((s) => {
    const data = s.data || []
    return data
      .map((point) => (typeof point === 'object' && point.y != null ? point.y : point))
      .filter((v) => v != null && typeof v === 'number')
  })
  const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0
  // 保有資産初期値の上限が9.9999億円であり、取り崩していく範囲では10億円を超えない。
  // 初期上限値を超えたら億円単位で丸める。画面サイズ的にもちょうどよい。
  const isMaxLabelMoreThanBillion = maxValue >= 1000000000

  const options = {
    chart: {
      marginTop: breakPoint(isResponsive) ? _marginTop : _marginTop - 10,
      marginLeft: breakPoint(isResponsive) ? _marginLeft : _marginLeft - 10,
      marginRight: breakPoint(isResponsive) ? _marginRight : 20,
      marginBottom: breakPoint(isResponsive) ? _marginBottom : _marginBottom - 40,
      height: 450,
      backgroundColor: '#fdfbf7',
      borderRadius: 10,
      shadow: true,
      style: { fontFamily: fontFamily },
      width: isResponsive ? null : 1110, // TODO デザイン
      styleMode: true,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
      followTouchMove: false,
    },
    credits: {
      enabled: false,
    },
    title: { text: '' },

    xAxis: {
      crosshair: {
        width: 1,
        color: '#cccccc',
        snap: false,
      },
      gridLineWidth: 1,
      gridLineColor: '#e8e8e8',
      tickPositioner: function () {
        const positions = []
        for (let i = 0; i <= _dataLength; i++) {
          const age = i + startAge
          if (age === _highlightAge) positions.push(i)
          else if (age % _tickUnit === 0) positions.push(i)
        }
        return positions
      },
      labels: {
        useHTML: true,
        formatter: function () {
          const age = this.value + startAge
          if (breakPoint(isResponsive)) {
            if (age === _highlightAge) {
              return `<div style="border:solid 2px #f98197;border-radius:3px;">
                    <div style="background-color: #f98197;text-align:center;"
                    class="reversalChart highlightAge">
                    <span style="color:#fdfbf7;text-shadow:none;font-size:1.6rem;
                    white-space:nowrap;">
                    ${age}歳</span></div></div>`
            }
            const spanStyle =
              'color:#000;text-shadow:none;font-size:1.2rem;width:auto !important;' +
              'max-width:none !important;display:inline-block;'
            return `<span style="${spanStyle}">${age}歳</span>`
          } else {
            const marginStr = this.value % _tickUnit === 0 ? '' : 'margin-top:15px;'

            // turningAge と _highlighAge の値が近く、なおかつどちらも等間隔の目盛り線上にない場合はさらにy軸をずらす
            const highlightMarginStr = () => {
              return marginStr
            }
            const divStyle =
              'color:#000;text-shadow:none;font-size:1.2rem;width:auto !important;' +
              'max-width:none !important;'
            const spanStyle = divStyle + 'display:inline-block;'
            if (marginStr === '') return `<span style="${spanStyle}">${age}歳</span>`
            else if (age === _highlightAge)
              return `<div style="${divStyle}${highlightMarginStr()}">${age}歳</div>`
            else return `<div style="${divStyle}${marginStr}">${age}歳</div>`
          }
        },
      },
    },
    yAxis: {
      min: 0,
      gridLineColor: '#e8e8e8',
      labels: {
        style: {
          color: '#43425D',
          fontSize: '1.2rem',
        },
        formatter: function () {
          return (this.value / (isMaxLabelMoreThanBillion ? 100000000 : 10000))
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
      },
      title: {
        text: isMaxLabelMoreThanBillion ? '(億円)' : '(万円)',
        rotation: 0,
        align: 'high',
        offset: 20,
        style: {
          color: '#43425D',
        },
        y: -10,
      },
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        events: {
          legendItemClick: function (e) {
            const t = e.browserEvent && e.browserEvent.target
            // 見出し部分ならトグルを止める
            if (t && t.closest && t.closest('.lg__head')) {
              e.preventDefault()
              return false
            }
          },
        },
        lineWidth: 3,
      },
      line: {
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    series: series,
  }

  chart = Highcharts.chart(id, options)

  // マウスカーソルの追従でonHoverを発火＆crosshairを整数位置にスナップ
  let lastAfterAge = null
  Highcharts.addEvent(chart.container, 'mousemove', function (e) {
    if (!chart.xAxis || !chart.xAxis[0]) return

    // Highchartsのnormalizeメソッドで正しい座標を取得
    const event = chart.pointer.normalize(e)
    const xValue = chart.xAxis[0].toValue(event.chartX, false)
    // 整数年齢にスナップ
    const afterAge = Math.round(xValue)

    // 範囲内の場合のみcrosshairを描画
    if (afterAge >= 0 && afterAge <= _dataLength) {
      // 整数位置にスナップしたcrosshairを手動描画
      const snappedPixels = chart.xAxis[0].toPixels(afterAge, false)
      const snappedEvent = { ...event, chartX: snappedPixels }
      chart.xAxis[0].drawCrosshair(snappedEvent)

      // onHoverコールバック呼び出し
      if (typeof safeOnHover.onHover === 'function' && afterAge !== lastAfterAge) {
        lastAfterAge = afterAge
        safeOnHover.onHover({ afterAge })
      }
    }
  })

  // マウスが離れた時にcrosshairを消す
  Highcharts.addEvent(chart.container, 'mouseleave', function () {
    if (chart.xAxis && chart.xAxis[0]) {
      chart.xAxis[0].hideCrosshair()
    }
  })

  // 100歳ラベルの位置を保存（DOM再生成に対応）
  let saved100AgeLeft = null

  // 100歳ラベルの幅制限を監視して解除
  const observer = new MutationObserver((mutations) => {
    observer.disconnect()

    const labels = document.querySelectorAll('.highcharts-xaxis-labels span')
    labels.forEach((label) => {
      if (label.innerHTML.includes('100歳')) {
        const computedWidth = window.getComputedStyle(label).width
        const currentLeft = parseFloat(label.style.left)

        // 初回のみ位置を計算
        if (
          saved100AgeLeft === null &&
          computedWidth !== 'auto' &&
          !computedWidth.includes('auto')
        ) {
          const restrictedWidth = label.offsetWidth

          label.style.setProperty('width', 'auto', 'important')
          label.style.setProperty('max-width', 'none', 'important')

          const actualWidth = label.offsetWidth
          const offset = (actualWidth - restrictedWidth) / 2
          saved100AgeLeft = currentLeft - offset
          label.style.left = `${saved100AgeLeft}px`
        } else if (saved100AgeLeft !== null) {
          // 2回目以降: 幅とleftを常に正しい値に修正
          label.style.setProperty('width', 'auto', 'important')
          label.style.setProperty('max-width', 'none', 'important')
          // 0.1px以上ずれている場合のみ修正（不要な再設定でプルプルするのを防ぐ）
          if (Math.abs(currentLeft - saved100AgeLeft) > 0.1) {
            label.style.left = `${saved100AgeLeft}px`
          }
        }
      }
    })

    observer.observe(chart.container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    })
  })

  if (chart.container) {
    observer.observe(chart.container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    })
  }

  // チャート破棄時にObserverもクリーンアップ
  const originalChartDestroy = chart.destroy
  chart.destroy = function () {
    observer.disconnect()
    originalChartDestroy.call(this)
  }

  // SP版: スクロール時にホバー解除（縦線を消す）
  if (!breakPoint(isResponsive)) {
    const scrollHandler = () => {
      if (chart && chart.pointer) {
        chart.pointer.reset()
      }
    }
    window.addEventListener('scroll', scrollHandler, { passive: true })

    // チャート破棄時にリスナーをクリーンアップ
    const originalDestroy = chart.destroy
    chart.destroy = function () {
      window.removeEventListener('scroll', scrollHandler)
      originalDestroy.call(this)
    }
  }

  return chart
}

export function resetChart() {
  if (chart) {
    chart.destroy()
    chart = null
  }
}

export function toggleSeriesVisibility(key, setActiveKeys) {
  if (!chart) return

  const series = chart.series.find((s) => s.options.key === key)
  if (series) {
    series.setVisible(!series.visible, false) // 表示・非表示を切り替え
    setActiveKeys((prevKeys) => {
      return { ...prevKeys, [key]: series.visible }
    })
    chart.redraw() // 再描画
  }
}

function calcCofficient(isResponsive) {
  if (window.innerWidth > 960 || !isResponsive) {
    return 1 // デスクトップ
  } else if (window.innerWidth > 640) {
    return 2 // タブレット
  } else {
    return 4 // スマホ
  }
}
function calcTickUnit(dataLength, tickTotal, isResponsive) {
  const tickRawUnit = dataLength / tickTotal
  const coefficient = calcCofficient(isResponsive)
  switch (true) {
    case tickRawUnit >= 10:
      return 10 * coefficient
    case tickRawUnit >= 5:
      return 5 * coefficient
    // スマホ版でメモリ間隔が広すぎるので調整
    case tickRawUnit >= 2 && coefficient > 2:
      return 10
    default:
      return 5
  }
}
